import React from 'react';
import moment from 'moment';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import { useUserSettingsContext } from 'users/utils/contexts/UserSettingsContext';
import styles from './barsChart.module.scss';
import { CustomTooltipProps } from '../../../types.ts';
import { formatQuarterlyDate } from './utils.ts';

const getDateFormat = (date: string | number | Date, formatType: string | null | undefined): string => {
  if (!formatType) {
    return moment(date).format('MMM DD YYYY');
  }
  switch (formatType) {
    case 'daily':
      return moment(date).format('MMM DD YYYY');
    case 'monthly':
      return moment(date).format('MMM YYYY');
    case 'quarterly':
      return formatQuarterlyDate(date.toString());
    default:
      return moment(date).format('MMM DD YYYY');
  }
};

export const CustomTooltip: React.FC<CustomTooltipProps> = ({ payload, formatType }) => {
  const { getCurrencyNumber } = useUserSettingsContext();

  if (!payload?.length) {
    return null;
  }

  const dataPoint = payload[0]?.payload ?? {};
  const total = Object.keys(dataPoint)
    .filter((pointKey) => pointKey !== 'usageDate')
    .reduce((sum, pointKey) => sum + (dataPoint[pointKey] ? Number(dataPoint[pointKey]) : 0), 0);

  return (
    <div className={styles.customizedTooltip}>
      <div className={styles.tooltipTitleContainer}>
        <GenerateIcon iconName={ICONS.calendarDay.name} />
        <div className={styles.tooltipTitle}>{getDateFormat(dataPoint.usageDate, formatType)}</div>
      </div>
      <div className={styles.dataWrapper}>
        {payload.map((pointKey) => (
          <div key={`${pointKey.dataKey}-${pointKey.value}`} className={styles.tooltipRow}>
            <div className={styles.tooltipValue}>
              <div className={styles.keyWrapper}>
                <svg width="14" height="10" className={styles.legend}>
                  <rect width="14" height="10" fill={pointKey.color} />
                </svg>
                <span>
                  {pointKey.dataKey.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^\w/, (c) => c.toUpperCase())}
                </span>
              </div>
              <span>{getCurrencyNumber(pointKey.value)}</span>
            </div>
          </div>
        ))}
        {payload.length > 1 && (
          <div className={styles.summaryRow}>
            <span>Total</span>
            <span>{getCurrencyNumber(total)}</span>
          </div>
        )}
      </div>
    </div>
  );
};
